import $ from 'jquery';


class CircleOfCareLogic {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.circle-content li a').hover((e) => {
            let $this = $(e.currentTarget);
            let $thisImage = $this.closest('li').attr('data-active');
            let $imgContainer = $this.closest('ul').siblings('.hoverImage');

            $imgContainer.attr('src', $thisImage);
            $this.closest('li').siblings('li').removeClass('is-hovered');
            $this.closest('li').addClass('is-hovered');
        });

        $('.circle-content li a').click(e => {
            e.preventDefault();
            e.stopPropagation();
            let $this = $(e.currentTarget);
            let $thisAlt = $this.closest('li').attr('data-alt');
            let $thisImage = $this.closest('li').attr('data-active');
            let $imgContainer = $this.closest('ul').siblings('.activeImage');
            let $descriptions = $('.description-coc');
            let thisID = $this.closest('li').attr('id');

            $imgContainer.attr('src', $thisImage).attr('alt', $thisAlt);
            $this.closest('li').siblings('li').removeClass('is-active');
            $this.closest('li').addClass('is-active');

            $descriptions.each((i, e) => {
                let classes = $(e).attr('class');
                classes = classes.replace('description-coc', '').replace('is-hidden', '').trim();

                if (classes === thisID) {
                    $(e).removeClass('is-hidden');
                } else {
                    $(e).addClass('is-hidden');
                }
            });
        });

        $('.circle-content').hover((e) => {}, (e) => {
            let $this = $(e.currentTarget);
            let $imgContainer = $this.find('.hoverImage');
            let $li = $this.find('li');

            $li.removeClass('is-hovered');
            $imgContainer.attr('src', 'content/images/custom/none.gif');
        });
    }
}

export default CircleOfCareLogic;

$(() => {
	const circleOfCareLogic = new CircleOfCareLogic();
	circleOfCareLogic.init();
});
